<template>
  <path
    d="M12 2.00024C6.48 2.00024 2 6.48024 2 12.0002C2 17.5202 6.48 22.0002 12 22.0002C17.52 22.0002 22 17.5202 22 12.0002C22 6.48024 17.52 2.00024 12 2.00024ZM16.5 16.0002H8C6.34 16.0002 5 14.6602 5 13.0002C5 11.3402 6.34 10.0002 8 10.0002H8.14C8.58 8.27024 10.13 7.00024 12 7.00024C14.21 7.00024 16 8.79024 16 11.0002H16.5C17.88 11.0002 19 12.1202 19 13.5002C19 14.8802 17.88 16.0002 16.5 16.0002Z"
  />
</template>
